import { takeLatest, all, put } from 'redux-saga/effects';
import { Actions } from '../action';
import { doGet, doPost } from '../../config';
import { ResponseGenerator } from './SagaInterface';
import END_POINTS from '../../config/Endpoints';
import { DASHBOARD_LIST } from '../action/DashboardAction';
export function* DashboardListSaga(param: any) {
    const { params, callback } = param
    try {
        const response: ResponseGenerator = yield doGet(END_POINTS.DASHBOARD_LIST, params, '')
        yield put(Actions.dashboardListSuccess(response));
        callback && callback(response)
    } catch (error) {
        yield put(Actions.dashboardListFailure({ error }));
        callback && callback({ error })
    }
}
export default function* dashboardWatcher() {
    yield all([
        takeLatest(DASHBOARD_LIST, DashboardListSaga),
    ]);
}
